<script>
import { required } from "vuelidate/lib/validators";
import {cloneDeep} from 'lodash';
import DatePicker from "vue2-datepicker";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
export default {
    name: 'RfqModal',
    props: {
        modalTitle: String,
    },
    components: {
        DatePicker,
        MaskedInput,
    },
    data(){
        return {
            submitted: false,
            currencyMask: createNumberMask({
                prefix: "",
                allowDecimal: true,
            }),
            rfq: {
                id: 0,
                prId: 0,
                description: null,
                tracking: null,
                deadline: null,
                note: null,
                dateSubmitted: null,
                yearsRequired: null,
                bidDocsAvailableDate: null,
                bidDocsAmount: null,
                bidOpeningDate: null,
                bidSecurityValidUntil: null,
                slccPercentageRequired: null,
                subContractingAllowed: false,
                projectAwardedAs: null,
                rfqNumber: null,
            }
        }
    },
    validations: {
        rfq: {
            description: {required},
            deadline: {required},
            bidDocsAvailableDate: {required},
            bidOpeningDate: {required},
            bidSecurityValidUntil: {required},
        }
    },
    methods: {
        updateData(data){
            this.rfq = cloneDeep(data);
            this.rfq.bidDocsAmount = !data.bidDocsAmount ? '0' : data.bidDocsAmount.toString();
            this.rfq.yearsRequired = !data.yearsRequired ? '0' : data.yearsRequired.toString();
            this.rfq.bidNumber = data.rfqNumber;
            this.rfq.slccPercentageRequired = !data.slccPercentageRequired ? '0' : data.slccPercentageRequired.toString();
            this.rfq.deadline = data.deadline ? new Date(data.deadline) : '';
            this.rfq.dateSubmitted = data.dateSubmitted ? new Date(data.dateSubmitted) : '';
            this.rfq.bidDocsAvailableDate = data.bidDocsAvailableDate ? new Date(data.bidDocsAvailableDate) : '';
            this.rfq.bidOpeningDate = data.bidOpeningDate ? new Date(data.bidOpeningDate) : '';
            this.rfq.bidSecurityValidUntil = data.bidSecurityValidUntil ? new Date(data.bidSecurityValidUntil) : '';
            this.submitted = false;
        },
        onCreateRfq(){
            this.submitted = true;
            this.$v.rfq.$touch();
            if (this.$v.rfq.$invalid) {
                return;
            }
            let data = cloneDeep(this.rfq);
            data.deadline = this.getDate(this.rfq.deadline);
            data.bidDocsAmount = this.getExactAmt(this.rfq.bidDocsAmount);
            data.dateSubmitted = !this.rfq.id ? this.getDate(new Date()) : this.getDate(this.rfq.dateSubmitted);
            data.bidDocsAvailableDate = this.getDate(this.rfq.bidDocsAvailableDate);
            data.bidOpeningDate = this.getDate(this.rfq.bidOpeningDate);
            data.slccPercentageRequired = this.getExactAmt(this.rfq.slccPercentageRequired);
            data.bidSecurityValidUntil = this.getDate(this.rfq.bidSecurityValidUntil);
            data.rfqNumber = this.rfq.bidNumber;
            this.$emit('saveRfq', data);
        }
    }
}
</script>
<template>
    <b-modal 
        id="create-rfq"
        :title="modalTitle"
        size="lg"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop    
    >
        <form @submit.prevent="onCreateRfq" class="needs-validation">
            <div class="row">
                <div class="col-md-6">
                    <!-- <div class="mb-3">
                        <label for="bidNumber">Bid Number</label>
                        <input
                            name="note"
                            id="bidNumber"
                            type="text"
                            placeholder="Enter Bid Number"
                            class="form-control text-warning"
                            autocomplete="off"
                            v-model="rfq.bidNumber"
                        />
                    </div> -->
                    <div class="mb-2">
                        <label for="description">Description</label>
                        <textarea
                            rows="4"
                            placeholder="Description"
                            class="form-control text-warning"
                            v-model="rfq.description"
                            :class="{'is-invalid': submitted && $v.rfq.description.$error}"
                        >
                        </textarea>
                        <div
                            v-if="submitted && $v.rfq.description.$error"
                            class="invalid-feedback"
                        >
                            <span v-if="!$v.rfq.description.required">This value is required.</span>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="dateSubmitted">Date of Issue</label>
                        <date-picker
                            v-model="rfq.bidOpeningDate"
                            :first-day-of-week="1"
                            lang="en"
                            placeholder="Enter Date of Issue..."
                            type="datetime"
                            :class="{'is-invalid': submitted && $v.rfq.bidOpeningDate.$error}"
                            :time-picker-options="{start: '00:00', step:'00:30' , end: '23:30', format: 'hh:mm A'}"
                            input-class="text-warning form-control"
                        ></date-picker>
                        <div
                            v-if="submitted && $v.rfq.bidOpeningDate.$error"
                            class="invalid-feedback"
                        >
                            <span v-if="!$v.rfq.bidOpeningDate.required">This value is required.</span>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="dateSubmitted">Bid Docs Available Date</label>
                        <date-picker
                            v-model="rfq.bidDocsAvailableDate"
                            :first-day-of-week="1"
                            lang="en"
                            placeholder="Enter Bid Docs Available Date..."
                            type="datetime"
                            :class="{'is-invalid': submitted && $v.rfq.bidDocsAvailableDate.$error}"
                            :time-picker-options="{start: '00:00', step:'00:30' , end: '23:30', format: 'hh:mm A'}"
                            input-class="text-warning form-control"
                        ></date-picker>
                        <div
                            v-if="submitted && $v.rfq.bidDocsAvailableDate.$error"
                            class="invalid-feedback"
                        >
                            <span v-if="!$v.rfq.bidDocsAvailableDate.required">This value is required.</span>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="deadline">Bids Submission Deadline</label>
                        <date-picker
                            v-model="rfq.deadline"
                            :first-day-of-week="1"
                            lang="en"
                            placeholder="Enter Bids Submission Deadline..."
                            :class="{'is-invalid': submitted && $v.rfq.deadline.$error}"
                            type="datetime"
                            :time-picker-options="{start: '00:00', step:'00:30' , end: '23:30', format: 'hh:mm A'}"
                            input-class="text-warning form-control"
                        ></date-picker>
                        <div
                            v-if="submitted && $v.rfq.deadline.$error"
                            class="invalid-feedback"
                        >
                            <span v-if="!$v.rfq.deadline.required">This value is required.</span>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="dateSubmitted">Bid Docs Amount</label>
                        <masked-input
                            autocomplete="off"
                            type="text"
                            v-model="rfq.bidDocsAmount"
                            placeholder="Enter Amount..."
                            class="form-control"
                            :mask="currencyMask"
                        >
                        </masked-input>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="mb-3">
                        <label for="dateSubmitted">Years Required</label>
                        <masked-input
                            autocomplete="off"
                            type="text"
                            v-model="rfq.yearsRequired"
                            placeholder="Enter Years..."
                            class="form-control"
                            :mask="currencyMask"
                        >
                        </masked-input>
                    </div>
                    <div class="mb-3">
                        <label for="dateSubmitted">Bid Security Valid Until</label>
                        <date-picker
                            v-model="rfq.bidSecurityValidUntil"
                            :first-day-of-week="1"
                            lang="en"
                            placeholder="Enter Bid Security Valid Until..."
                            input-class="text-warning form-control"
                            :class="{'is-invalid': submitted && $v.rfq.bidSecurityValidUntil.$error}"
                        ></date-picker>
                        <div
                            v-if="submitted && $v.rfq.bidSecurityValidUntil.$error"
                            class="invalid-feedback"
                        >
                            <span v-if="!$v.rfq.bidSecurityValidUntil.required">This value is required.</span>
                        </div>
                    </div>
                    <div class="mb-3">
                        <div class="mb-3">
                            <label>SLCC Percentage Required</label>
                            <masked-input
                                autocomplete="off"
                                type="text"
                                v-model="rfq.slccPercentageRequired"
                                placeholder="Enter Percentage..."
                                class="form-control"
                                :mask="currencyMask"
                            >
                            </masked-input>
                        </div>
                    </div>
                    <div class="form-check form-checkbox-outline form-check-success mb-3">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            id="isPaidOnline"
                            v-model="rfq.subContractingAllowed"
                        />
                        <label class="form-check-label" for="isPaidOnline">
                            Subcontracting Allowed
                        </label>
                    </div>
                    <div class="mb-3">
                        <label for="projectAwardedAs">Project Awarded As</label>
                        <input
                            name="note"
                            id="projectAwardedAs"
                            type="text"
                            placeholder="Enter Project Awarded As"
                            class="form-control text-warning"
                            autocomplete="off"
                            v-model="rfq.projectAwardedAs"
                        />
                    </div>
                    <div class="mb-3">
                        <label for="rfqNote">Notes</label>
                        <textarea
                            name="note"
                            id="rfqNote"
                            rows="2"
                            placeholder="Enter Notes"
                            class="form-control text-warning"
                            v-model="rfq.note"
                        ></textarea>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-primary">
                    Save changes
                </button>
                <button
                    type="button"
                    class="btn btn-link"
                    @click="$bvModal.hide('create-rfq')"
                >
                    Close
                </button>
            </div>
        </form>
    </b-modal>
</template>